export const getGroupNames = (bankGroups: { id: string; name: string }[], groupIds: string[]): string[] =>
  groupIds.map((id) => bankGroups.find((group) => group.id === id)?.name ?? '--');
